import { motion } from "framer-motion";

const routes = [
    { a: "İstanbul", b: "Ankara", km: "453 km" },
    { a: "İzmir", b: "Bodrum", km: "244 km" },
    { a: "Ankara", b: "Trabzon", km: "771 km" },
    { a: "Antalya", b: "Fethiye", km: "197 km" },
    { a: "Bursa", b: "Çanakkale", km: "318 km" },
    { a: "Adana", b: "Mersin", km: "69 km" },
    { a: "Konya", b: "Kapadokya", km: "230 km" },
    { a: "Samsun", b: "Rize", km: "323 km" },
    { a: "Eskişehir", b: "Sakarya", km: "253 km" },
    { a: "Gaziantep", b: "Şanlıurfa", km: "145 km" },
];

function RouteChip({ a, b, km }) {
    return (
        <div className="flex items-center gap-3 px-5 py-2.5 rounded-full bg-[#111115] border border-white/[0.07] whitespace-nowrap">
            <span className="w-1.5 h-1.5 rounded-full bg-[#00F0FF] shadow-[0_0_6px_#00F0FF]" />
            <span className="font-display font-medium text-white/90 text-sm tracking-tight">{a}</span>
            <svg width="14" height="10" viewBox="0 0 20 10" fill="none" className="text-white/35">
                <path d="M1 5 H17 M13 1 L17 5 L13 9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span className="font-display font-medium text-white/90 text-sm tracking-tight">{b}</span>
            <span className="w-1.5 h-1.5 rounded-sm bg-[#FF2D92] shadow-[0_0_6px_#FF2D92]" />
            <span className="text-[11px] text-white/45 font-mono ml-1">{km}</span>
        </div>
    );
}

export default function Marquee() {
    const row = [...routes, ...routes];
    return (
        <section data-testid="marquee-section" className="relative py-16 overflow-hidden border-y border-white/5">
            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7 }}
                className="relative"
            >
                {/* Edge fade masks */}
                <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#0a0a0c] to-transparent z-10" />
                <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#0a0a0c] to-transparent z-10" />

                <div className="marquee-track flex gap-4 w-max">
                    {row.map((r, i) => (
                        <RouteChip key={`a-${i}`} {...r} />
                    ))}
                </div>
                <div className="marquee-track-2 flex gap-4 w-max mt-4">
                    {row.slice().reverse().map((r, i) => (
                        <RouteChip key={`b-${i}`} {...r} />
                    ))}
                </div>
            </motion.div>
        </section>
    );
}
